// @core/api/endpoints/apikey/activate_api_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyResponse,
  ActivateAPIKeyRequest,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Activate API key
 * Reactivates a suspended API key, restoring access immediately. Cannot reactivate revoked keys; use regenerate instead.
 */
export async function ActivateAPIKey(
  key_id: string,
  data: ActivateAPIKeyRequest,
  options?: RequestOptions
): Promise<APIKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:key_id/activate`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.post<APIKeyResponse>(requestPath, data, requestOptions);
}
